export const projectData = [
    {
        id: 0,
        title: 'Creative Agency',
        description: "Creative agency is a single page application for an Agency who provides IT services",
        image: './image/portfolio/creative-agency.JPG',
        github: 'https://github.com/FAsami/creative-agency-client',
        website: 'https://creative-agency-fasami.web.app/'
    },
    {
        id: 1,
        title: 'Volunteer Network',
        description: "Volunteer network an web app for finding volunteer work opportunities where users can find volunteer work to work on.",
        image: './image/portfolio/volunteer-network.JPG',
        github: 'https://github.com/FAsami/volunteer-network-client',
        website: 'https://volunteer-network-fasami.web.app/'
    },
    {
        id: 2,
        title: 'Travel Guru',
        description: "Travel Guru is an web app for getting information about places and find rooms nearby",
        image: './image/portfolio/travel-guru.JPG',
        github: 'https://github.com/FAsami/travel-guru',
        website: 'https://travel-guru-a8924.web.app'
    },
    {
        id: 3,
        title: 'Red Onion',
        description: "Red onion is restaurant website for ordering food online. Where users can order food online and get order details ",
        image: './image/portfolio/red-onion.JPG',
        github: 'https://github.com/FAsami/hot-onion',
        website: 'https://hot-onion-fasami.web.app/'
    },
]